import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { getAll } from '../api/ventura/lineItem';
import { useConfig } from './useConfig';

function useLineItems(contractId: number, defaultPage = 0, defaultPerPage = 9999) {
  // The nested IO index opts into the per-domain flip: apiHostFor('insertionOrders')
  // resolves to ACH iff insertionOrders is flipped ON (migrated list + env gate),
  // else the plain Rails apiHost. The index envelope {collection,pagination} is
  // shape-identical for what these consumers read (the `collection` array only —
  // the grid pages client-side and no consumer reads the pagination meta, so
  // RD-3's meta-key changes are invisible), so only the host switches: no
  // response adaptation.
  const { apiHostFor } = useConfig();
  const insertionOrdersHost = apiHostFor('insertionOrders');
  const [page, setPage] = useState(defaultPage);
  const [perPage, setPerPage] = useState(defaultPerPage);

  const lineItems = useQuery({
    queryKey: ['lineItems', contractId, page, perPage],
    queryFn: () => getAll(insertionOrdersHost, contractId, { page, perPage }),
    enabled: !!contractId,
  });

  return { page, setPage, perPage, setPerPage, ...lineItems };
}

export default useLineItems;
